import CONSTANTS from '../constants'
import { isLoggedIn } from '../../utils/helper'
import { EMPTY_ARRAY } from '../../constants/globalConstants'

const INITIAL_STATE = {
	loader: true,
	isUserLogin: isLoggedIn(),
	isAuthenticated: false,
	hasError: false,
	data: EMPTY_ARRAY,
	email: null,
	role: null,
	errorMessage: '',
	id: null,
	orgId: '',
	activeSession: true
}

const PaymentReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		//LOGIN HANDLING
		case CONSTANTS.GET_CARD_LIST_REQUEST:
			return { ...state, loader: true, errorMessage: '' }
		case CONSTANTS.GET_CARD_LIST_SUCCESS:
			return { ...state, loader: false, data: action.data, isAuthenticated: true, hasError: false, errorMessage: '' }
		case CONSTANTS.GET_CARD_LIST_FAILURE:
			return { ...state, loader: false, errorMessage: 'There is some Error' }
		case CONSTANTS.CARD_UPDATE_REQUEST:
			return { ...state, loader: true }
		case CONSTANTS.CARD_UPDATE_SUCCESS:
			return { ...state, loader: false }
		case CONSTANTS.CARD_UPDATE_FAILED:
			return { ...state, loader: false }
		case CONSTANTS.SET_ACTIVE_SESSION:
			return { ...state, activeSession: action?.payload }
		default:
			return state
	}
}

export default PaymentReducer